<span class="trendText_TrendData">
    <mat-icon class="trendText_TrendIcon" [ngStyle]="{'color':color}">{{iconName}}</mat-icon>
    @if(trendPresentationScore != 0){
    <span class="trendText_trendValue" [ngStyle]="{'color':color, 'fontSize':fontSize}">{{trendPresentationScore}}% </span>
    }
    @else{
        <span class="trendText_trendText" [ngStyle]="{'fontSize':fontSize}">{{"scoreTrend.noChange" | translate}} </span>
    }
    <span  class="trendText_trendText" [ngStyle]="{'fontSize':fontSize}">{{"teamMemberView.trendPeriodForComparison" | translate}}</span>
    <!-- <span *ngIf="isUnknownTrendValue" class="trendText_trendText" [ngStyle]="{'fontSize':fontSize}">{{"teamMemberView.trendMissingData" | translate}}</span> -->
</span>